/**
 * Utilitário genérico para processar dados vindos do MongoDB que podem estar em formato de string (dump).
 * @param data O dado a ser processado (pode ser string ou objeto)
 * @returns O dado processado como o tipo T ou o dado original
 */
export function parseMongoData<T>(data: any): T {
  if (typeof data !== "string") return data as T;

  if (!data.trim().startsWith("{")) return data as T;

  try {
    let jsonStr = data.replace(
      /(?:new\s+)?ObjectId\(['"]([^'"]+)['"]\)/g,
      '"$1"',
    );

    jsonStr = jsonStr.replace(/ISODate\(['"]([^'"]+)['"]\)/g, '"$1"');

    jsonStr = jsonStr.replace(
      /:\s*(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)/g,
      ': "$1"',
    );

    jsonStr = jsonStr.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');

    jsonStr = jsonStr.replace(/:\s*'([^']*)'/g, ': "$1"');

    jsonStr = jsonStr.replace(/,\s*([}\]])/g, "$1");

    return JSON.parse(jsonStr) as T;
  } catch (error) {
    console.warn("Falha ao processar dump genérico do MongoDB:", error);
    return data as T;
  }
}
